// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2FBIK","notes":"Notes_notes__26Lgr"};